export var SET_FILTER_VALUE = 'SET_FILTER_VALUE';
export var SET_PAGE = 'SET_PAGE';
export var SET_PAGE_SIZE = 'SET_PAGE_SIZE';
export var SET_SORTED = 'SET_SORTED';
export var SET_COLUMNS = 'SET_COLUMNS';
export var SET_EDITED_ROW = 'SET_EDITED_ROW';